import Text from '../../../../../Text'
import alernative1AlternativeSvg from '../../svgs/alternative/1alternative.svg'
import alternativeSectionSvg from '../../svgs/alternative/section.svg'
import dental1DentalSvg from '../../svgs/dental/1dental.svg'
import dental2OrthodonticsSvg from '../../svgs/dental/2orthodontics.svg'
import dental3ImplantsSvg from '../../svgs/dental/3implants.svg'
import dental4ProthesisSvg from '../../svgs/dental/4prothesis.svg'
import dentalSectionSvg from '../../svgs/dental/section.svg'
import generalCare1CareSvg from '../../svgs/generalCare/1care.svg'
import generalCare2ImagingSvg from '../../svgs/generalCare/2imaging.svg'
import generalCare3PhysioSvg from '../../svgs/generalCare/3physio.svg'
import generalCare4TechnicalSvg from '../../svgs/generalCare/4technical.svg'
import generalCareSectionSvg from '../../svgs/generalCare/section.svg'

import classNames from 'classnames'
import Svg from '../../../../../Svg'
import { maxW } from '../../WebStep01IndexPage'
import { WebCareIcons } from './WebCareIcons'

export const WebStep01IndexGreySection = () => (
  <div
    className={classNames(
      'bg-blueHover',
      // Center the components in the container
      //'flex justify-center w-full min-h-screen',
      'flex justify-center w-full',
      'pt-6 pb-14 md:pt-14 lg:pt-10'
    )}
  >
    <div
      className={classNames(
        'flex flex-col lg:flex-row ',
        // Limit width
        maxW,
        'lg:space-x-10 space-y-12 lg:space-y-0'
      )}
    >
      <GreyCareSection />

      <div className="lg:max-w-[480px]">
        <GreyInfoSection />
      </div>
    </div>
  </div>
)

const GreyCareSection = () => (
  <div>
    <div className="text-base sm:text-xl mb-6 lg:mb-12">
      <div className="font-bold lg:text-xl">Les soins pris en charge :</div>
    </div>

    <div className="space-y-11 sm:space-y-4">
      <GreyCareCards
        title="Soins dentaires"
        icon={dentalSectionSvg}
        careCategories={[
          { labels: ['Soins', 'dentaires'], icon: dental1DentalSvg },
          { labels: ['Ortho-', 'dontie'], icon: dental2OrthodonticsSvg },
          { labels: ['Implanto-', 'logie'], icon: dental3ImplantsSvg },
          { labels: ['Prothèse', 'dentaire'], icon: dental4ProthesisSvg },
        ]}
      />

      <GreyCareCards
        title="Médecine de ville"
        icon={generalCareSectionSvg}
        careCategories={[
          { labels: ['Soins', 'courants'], icon: generalCare1CareSvg },
          { labels: ['Actes', 'd’imagerie'], icon: generalCare2ImagingSvg },
          { labels: ['Kiné', 'Infirmière'], icon: generalCare3PhysioSvg },
          { labels: ['Actes', 'Techniques'], icon: generalCare4TechnicalSvg },
        ]}
      />

      <GreyCareCards
        title="Médecine douce"
        icon={alternativeSectionSvg}
        careCategories={[
          {
            labels: ['Médecine douce', '(Ostéopathe, Sophrologie, Psychologue, Kinésiologie...)'],
            icon: alernative1AlternativeSvg,
          },
        ]}
      />
    </div>
  </div>
)

const GreyCareCards = (props: {
  title: string
  icon: string
  careCategories: { icon: string; labels: string[] }[]
}) => (
  <div className="sm:flex sm:flex-row px-1 space-y-4 sm:space-y-0 ">
    <div className="flex-1 flex flex-row">
      <div>
        <Svg alt={props.title} height={50} src={props.icon} width={50} />
      </div>
      <div className="ml-5">
        <div className="text-sm sm:text-xl">
          <Text weight="semibold">{props.title}</Text>
        </div>
        <div className="text-sm sm:text-lg">
          <Text fontStyle="italic">
            {props.careCategories.length === 1
              ? '1 catégorie de soin'
              : `${props.careCategories.length} catégories de soins`}
          </Text>
        </div>
      </div>
    </div>

    <div className="flex-1 sm:max-w-[320px]">
      <WebCareIcons
        items={props.careCategories.map((careCategory) => ({
          labels: careCategory.labels,
          height: 50,
          width: 50,
          src: careCategory.icon,
        }))}
      />
    </div>
  </div>
)

const GreyInfoSection = () => (
  <div>
    <div className="font-bold lg:text-xl mb-5">Informations complémentaires&nbsp;:</div>

    <div className="text-sm lg:text-lg">
      myBooster vous permet d&apos;obtenir{' '}
      <span className="font-bold">jusqu’à 150€ de remboursement par catégorie et par personne</span> en fonction de
      l&apos;offre choisie avec un engagement de 12 mois.
    </div>
  </div>
)
